import React from 'react';
import { ELITE_TIER_MONTHLY_ALERT_LIMIT_US } from 'constants/haveListAlerts';
import FeatureCardLayout from './FeatureCardLayout';
import './SmsAlertsCard.css';

interface SmsAlertsCardProps {
  isElite: boolean;
  // Region-aware Elite monthly cap, resolved by the caller from the viewer's shipping
  // country. Defaults to the US cap so the card still reads correctly if rendered
  // without the prop.
  eliteCap?: number;
}

const SMS_ALERTS_ICON_URL =
  'https://trademagic-assets.s3.us-west-1.amazonaws.com/assets/icons/notifications_active_24dp.svg';

const SmsAlertsCard: React.FC<SmsAlertsCardProps> = ({
  isElite,
  eliteCap = ELITE_TIER_MONTHLY_ALERT_LIMIT_US,
}) => {
  const preview = (
    <div className="sms-alerts-card-preview">
      <div className="sms-alerts-card-bell">
        <img
          src={SMS_ALERTS_ICON_URL}
          alt=""
          width={56}
          height={56}
          className="sms-alerts-card-bell-icon"
        />
      </div>
    </div>
  );

  const cta = isElite ? (
    <p className="feature-card-aspirational" style={{ fontStyle: 'normal', color: '#22c55e' }}>
      You get {eliteCap} alerts per month
    </p>
  ) : null;

  return (
    <FeatureCardLayout
      title="SMS Alerts: Never miss a trade"
      description={`Get a text the moment a trader wants your card and can afford it. Elite includes ${eliteCap} alerts per month so you can act fast on the trades that matter.`}
      previewContent={preview}
      ctaContent={cta}
      className="sms-alerts-card"
    />
  );
};

export default SmsAlertsCard;
